
import { defineComponent, PropType } from 'vue'
import { RouteNavigationParams } from '~/utils/router'

export default defineComponent({
  name: 'SidebarItem',
  props: {
    icon: {
      type: String,
      default: ''
    },
    iconColor: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    isCollapsed: {
      type: Boolean,
      default: false
    },
    isVisible: {
      type: Boolean,
      default: true
    },
    to: {
      type: [String, Object] as PropType<string | RouteNavigationParams>,
      default: ''
    },
    activeBgColor: {
      type: String,
      default: 'bg-juniper-500/15'
    },
    hoverBgColor: {
      type: String,
      default: 'hover:bg-juniper-500/10'
    },
    replace: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    linkAttrs() {
      if (!this.to) {
        return {
          is: 'div'
        }
      }

      if (this.isExternalLink) {
        return {
          is: 'a',
          href: this.to
        }
      }

      return {
        is: 'nuxt-link',
        to: this.to,
        replace: this.replace
      }
    },
    isExternalLink(): boolean {
      if (!this.to) {
        return false
      }

      return (
        typeof this.to === 'string' &&
        (this.to.startsWith('mailto:') ||
          this.to.startsWith('https://') ||
          this.to.startsWith('http://'))
      )
    }
  }
})
